module.exports = __webpack_public_path__ + "img/91557.2fc037dd.svg";